import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';

export const completeInterviewKit = (react, javascript, angular, frontendSystemDesign, interviewPrep) => ({
  title: "Complete Interview Kit",
  subtitle: "Engineering Mastery",
  badge: "MEGA BUNDLE",
  icon: <DashboardIcon sx={{ fontSize: 40, color: '#3b82f6' }} />,
  description: "The ultimate frontend engineering curriculum. Master React internals, JavaScript mechanics, Angular enterprise patterns, and UI System Design.",
  features: [
    "V8 Engine & Event Loop Visualized",
    "React Fiber & Hooks Internals",
    "Angular RxJS & DI Patterns",
    "Frontend System Design Case Studies"
  ],
  isTrackLink: true,
  price: 999,
  mrp: 4999,
  topics: [
    ...(javascript ? javascript.topics : []),
    ...(react ? react.topics : []),
    ...(angular ? angular.topics : []),
    ...(frontendSystemDesign ? frontendSystemDesign.topics : []),
    ...(interviewPrep ? interviewPrep.topics : [])
  ]
});
